import { render } from "./WeightAndGoalWidget.vue?vue&type=template&id=dc3610ce&scoped=true"
import script from "./WeightAndGoalWidget.vue?vue&type=script&lang=js"
export * from "./WeightAndGoalWidget.vue?vue&type=script&lang=js"

import "./WeightAndGoalWidget.vue?vue&type=style&index=0&id=dc3610ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc3610ce"]])

export default __exports__